export function redirect (type, data) {
  switch (type) {
    case 1:
      document.write(
        '<form action="' +
          data.actionUrl +
          '" method="post" name="payForm" style="display:none">'
      )
      for (let name in data.params) {
        document.write(
          '<input type="hidden" name="' +
            name +
            '" value="' +
            data.params[name] +
            '" />'
        )
      }
      document.write('</form>')
      document.payForm.submit()
      break
    case 2:
    case 3:
    case 4:
    case 8:
      if (data.hostedUrl) {
        window.location.href = data.hostedUrl
      }
      break
  }
}



// WEBPACK FOOTER //
// ./src/util/order-redirect.js